// extracted by mini-css-extract-plugin
export var copyableField = "_l8-4";
export var customerBadge = "_l8-0";
export var customerInfoTitle = "_l8-2";
export var details = "_l8-1";
export var dropdownContainer = "_l8-5";
export var dropdownImage = "_l8-6";
export var editAssigneeForm = "_l8-a";
export var editButton = "_l8-3";
export var email = "_l8-7";
export var hidden = "_l8-d";
export var input = "_l8-8";
export var saveButton = "_l8-b";
export var shopifyIcon = "_l8-c";
export var suggestionBadge = "_l8-e";
export var suggestionText = "_l8-f";
export var username = "_l8-9";